import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import BrandLogo from './BrandLogo';

const Layout = () => {
  return (
    <div className="flex h-screen bg-[#0B1120] text-slate-200 overflow-hidden font-sans selection:bg-amber-500/30">
      <Sidebar />
      <div className="flex-1 flex flex-col h-full relative overflow-hidden">
        {/* Subtle background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[500px] bg-amber-500/[0.03] blur-[120px] rounded-full pointer-events-none"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-blue-500/[0.02] blur-[100px] rounded-full pointer-events-none"></div>
        
        <Header />
        
        <main className="flex-1 overflow-y-auto p-6 lg:p-8 z-[1] custom-scrollbar">
          <Outlet />
        </main>
        
        <footer className="py-4 px-8 flex items-center justify-between border-t border-slate-800/50 bg-slate-950/50 backdrop-blur-md text-slate-500 text-[10px] z-[1]">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 opacity-40 grayscale hover:opacity-100 hover:grayscale-0 transition-all cursor-default">
              <BrandLogo iconOnly className="w-3 h-3" />
              <span className="font-bold tracking-widest uppercase">ComplianceCloud v3.0</span>
            </div>
            <span className="text-slate-700">|</span>
            <span className="font-medium tracking-tight">System Status: <span className="text-emerald-500">Operational</span></span>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-medium">Made by LingLink AI and DigLab AI</span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Layout;